// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__QQT9B","search":"Settings_search__30dtA","filter":"Settings_filter__1RuRh"};